import React, {Component} from 'react'
import ManagerAction from './ManagerAction'

const ManagerDemoteAction = (props) => {
  return (
    <ManagerAction
      heading='Are you sure?'
      question='Are you sure you want to remove this user as a manager?'
      { ...props }
    />
  )
}

export default ManagerDemoteAction